import { useState } from "react";

import { Button } from "@/components/ui/button";

interface EmailDemoInputProps {
  calPath: string;
}

export default function EmailDemoInput({ calPath }: EmailDemoInputProps) {
  const [email, setEmail] = useState("");

  return (
    <div className="flex items-center bg-white rounded-full border border-ash-500 pl-5 pr-2 py-1 md:pl-6 md:pr-2 md:py-2 w-full max-w-md">
      <input
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 bg-transparent text-sm md:text-base text-ash-900 placeholder:text-ash-400 outline-none tracking-tight"
      />

      <Button
        size="lg"
        variant="rebolt-primary"
        data-cal-link={calPath}
        data-cal-config='{"layout":"month_view"}'
        className="h-12 rounded-full hidden md:block"
      >
        Book your demo
      </Button>

      <Button
        size="sm"
        variant="rebolt-primary"
        data-cal-link={calPath}
        data-cal-config='{"layout":"month_view"}'
        className="h-9 rounded-full block md:hidden"
      >
        Book your demo
      </Button>
    </div>
  );
}
